import React from 'react';

const Tittle = ({tittle, span}) => {
    return (
        <div className="Tittle">
            <h3>
                {tittle}
            </h3>
        </div>
    );
};

export default Tittle;